export default "__VITE_ASSET__3L6mZN9R__"